<template>
  <div>
    <div class="titles">
      后台用户列表
      <Button type="info" shape="circle" class="role01" size="small" icon="ios-add" @click="del">添加</Button>
      <Button type="error" shape="circle" class="role01" size="small" icon="ios-close" @click="del">删除</Button>
    </div>
    <Table border ref="selection" :columns="columns7" :data="data6"></Table>
    <div class="role02">
      <Page :total="100"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "adminUser",
    data() {
      return {
        columns7: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '名称',
            key: 'name',
            render: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'person'
                  }
                }),
                h('strong', params.row.name)
              ]);
            }
          },
          {
            title: '说明',
            key: 'age'
          },
          {
            title: '添加时间',
            key: 'address'
          },
          {
            title: '操作',
            key: 'action',
            width: 200,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.show(params.index)
                    }
                  }
                }, '查看'),
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.edit(params.index)
                    }
                  }
                }, '编辑'),
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.remove(params.index)
                    }
                  }
                }, '删除')
              ]);
            }
          }
        ],
        data6: [
          {
            name: 'John Brown',
            age: 18,
            address: 'New York No. 1 Lake Park'
          },
          {
            name: 'Jim Green',
            age: 24,
            address: 'London No. 1 Lake Park'
          },
          {
            name: 'Joe Black',
            age: 30,
            address: 'Sydney No. 1 Lake Park'
          },
          {
            name: 'Jon Snow',
            age: 26,
            address: 'Ottawa No. 2 Lake Park'
          }
        ]
      }
    },
    created() {
    },
    methods: {
      show(index) {
        this.$Modal.info({
          title: '用户详情',
          content: `姓名：${this.data6[index].name}<br>年龄：${this.data6[index].age}<br>地址：${this.data6[index].address}`
        })
      },
      remove(index) {
        this.data6.splice(index, 1);
      },
      edit(index) {//编辑用户
        console.log(index);
      },
      del() {//删除用户
        var me = this;
        me.$message.error('暂未选择数据');
      }
    }
  }
</script>

<style scoped>
  @import "adminUser.css";
</style>
